import React from 'react'
import PropTypes from 'prop-types'
import ScheduleDay from 'frontend/schedule/schedule-day'

export default function ScheduleWeek ({ room, ...props }) {
  return (
    <div className="week" data-room-id={room.id} key={room.id}>
      {room.dates.map(date => <ScheduleDay key={date.date} date={date} room={room} {...props} />)}
    </div>
  )
}

const propTypes = {
  ...ScheduleDay.propTypes,
  room: PropTypes.object.isRequired
}

delete propTypes.date

ScheduleWeek.propTypes = propTypes
